import React, { useState, useEffect, useRef } from 'react';
import "./LocationAutocomplete.css";

const LocationAutocomplete = ({ value, onChange, placeholder }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (value.length > 2 && showSuggestions) {
                fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(value)}&limit=3`)
                    .then((res) => res.json())
                    .then((data) => {
                        const items = data.features.map((f) => {
                            const p = f.properties;
                            const parts = [p.name, p.city, p.country].filter(Boolean);
                            return [...new Set(parts)].join(', ');
                        });
                        setSuggestions(items);
                    })
                    .catch((err) => console.error("Autocomplete fetch error:", err));
            } else {
                setSuggestions([]);
            }
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [value, showSuggestions]);

    const handleInputChange = (e) => {
        onChange(e.target.value);
        setShowSuggestions(true);
    };

    const handleSelect = (suggestions) => {
        onChange(suggestions);
        setShowSuggestions(false);
        setSuggestions([]);
    };

    return (
        <div className='autocomplete-wrapper' ref={wrapperRef}>
            <input
                type="text"
                value={value}
                onChange={handleInputChange}
                onFocus={() => setShowSuggestions(true)}
                placeholder={placeholder}
                className="autocomplete=input"
            />
            {showSuggestions && suggestions.length > 0 && (
                <ul className='autocomplete-dropdown'>
                    {suggestions.map((item, index) => (
                        <li key={index} onClick={() => handleSelect(item)}>
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LocationAutocomplete;
